import {
  Usuario,
  Holding,
  Cliente,
  Propiedad,
  Contacto,
  Caso,
  CasoPropiedad,
  Poder,
  Estudio,
  Solicitud,
  Gasto,
  EntradaBitacora,
  Documento,
  AnalisisEstudio,
  AnalisisEstudioPropiedad,
  EntradaBitacoraAnalisis,
  Reclamo,
  Cobro,
  Tesoreria,
  EventoEstado,
} from "../types";

// ============================================
// USUARIOS
// ============================================
export const usuarios: Usuario[] = [
  { id: 1, nombre: "Cristobal Berstein", email: "cristobal@gyg.cl", rol: "admin", activo: true },
  { id: 2, nombre: "Felipe Wenz", email: "felipe@gyg.cl", rol: "ejecutivo", activo: true },
  { id: 3, nombre: "Andrea Gonzalez", email: "andrea@gyg.cl", rol: "arquitecto", activo: true },
  { id: 4, nombre: "Juan Carlos Garcia", email: "jcarlos@gyg.cl", rol: "abogado", activo: true },
  { id: 5, nombre: "Maria Paz Lopez", email: "mpaz@gyg.cl", rol: "ejecutivo", activo: true },
];

// ============================================
// HOLDINGS
// ============================================
export const holdings: Holding[] = [
  {
    id: 1,
    nombre: "Grupo El Roble",
    descripcion: "Holding inmobiliario con presencia en RM y V Region",
    tipo: "cliente",
    fechaCreacion: "2024-01-15",
    activo: true,
  },
  {
    id: 2,
    nombre: "Inversiones Pacifico",
    descripcion: "Grupo constructor enfocado en edificios residenciales",
    tipo: "cliente",
    fechaCreacion: "2024-03-20",
    activo: true,
  },
  {
    id: 3,
    nombre: "Holding Minero Norte",
    descripcion: "Empresas relacionadas a mineria en zona norte",
    tipo: "cliente",
    fechaCreacion: "2024-05-10",
    activo: true,
  },
];

// ============================================
// CLIENTES
// ============================================
export const clientes: Cliente[] = [
  {
    id: 1,
    rut: "76.123.456-7",
    nombre: "Inversiones El Roble SpA",
    tipoCliente: "holding",
    estado: "activo",
    holdingId: 1,
    ejecutivoId: 2,
    abogadoId: 4,
    arquitectoId: 3,
    fechaCreacion: "2024-01-15",
    fechaActualizacion: "2024-10-01",
  },
  {
    id: 2,
    rut: "76.234.567-8",
    nombre: "Constructora Pacifico Ltda",
    tipoCliente: "holding",
    estado: "activo",
    holdingId: 2,
    ejecutivoId: 5,
    abogadoId: 4,
    fechaCreacion: "2024-03-20",
    fechaActualizacion: "2024-09-15",
  },
  {
    id: 3,
    rut: "76.345.678-9",
    nombre: "Minera Los Andes SA",
    tipoCliente: "holding",
    estado: "activo",
    holdingId: 3,
    ejecutivoId: 2,
    abogadoId: 4,
    arquitectoId: 3,
    fechaCreacion: "2024-05-10",
    fechaActualizacion: "2024-10-20",
  },
  {
    id: 4,
    rut: "12.345.678-9",
    nombre: "Juan Perez Rodriguez",
    tipoCliente: "persona_natural",
    estado: "activo",
    holdingId: 1,
    ejecutivoId: 5,
    fechaCreacion: "2024-06-01",
    fechaActualizacion: "2024-08-15",
  },
  {
    id: 5,
    rut: "76.456.789-0",
    nombre: "Inmobiliaria El Roble Dos SpA",
    tipoCliente: "holding",
    estado: "activo",
    holdingId: 1,
    ejecutivoId: 2,
    abogadoId: 4,
    fechaCreacion: "2024-07-01",
    fechaActualizacion: "2024-10-01",
  },
  {
    id: 6,
    rut: "15.678.901-2",
    nombre: "Sofia Martinez Lepe",
    tipoCliente: "persona_natural",
    estado: "activo",
    ejecutivoId: 5,
    fechaCreacion: "2024-08-10",
    fechaActualizacion: "2024-11-01",
  },
];

// ============================================
// PROPIEDADES
// ============================================
export const propiedades: Propiedad[] = [
  { id: 1, clienteId: 1, rol: "1234-56", comuna: "Las Condes", tipoTenencia: "propia", fechaCreacion: "2024-01-15", estadoPropiedad: "activa" },
  { id: 2, clienteId: 1, rol: "1234-57", comuna: "Las Condes", tipoTenencia: "propia", fechaCreacion: "2024-01-15", estadoPropiedad: "activa" },
  { id: 3, clienteId: 2, rol: "3456-78", comuna: "Providencia", tipoTenencia: "propia", fechaCreacion: "2024-03-20", estadoPropiedad: "activa" },
  { id: 4, clienteId: 2, rol: "3456-79", comuna: "Providencia", tipoTenencia: "propia", fechaCreacion: "2024-04-10", estadoPropiedad: "activa" },
  { id: 5, clienteId: 3, rol: "4567-89", comuna: "Antofagasta", tipoTenencia: "propia", fechaCreacion: "2024-05-10", estadoPropiedad: "activa" },
  { id: 6, clienteId: 3, rol: "4567-90", comuna: "Antofagasta", tipoTenencia: "propia", fechaCreacion: "2024-05-10", estadoPropiedad: "activa" },
  { id: 7, clienteId: 4, rol: "6789-01", comuna: "Nunoa", tipoTenencia: "leasing", rutLeasing: "76.999.888-7", fechaCreacion: "2024-06-01", estadoPropiedad: "activa" },
  { id: 8, clienteId: 5, rol: "2345-67", comuna: "Vitacura", tipoTenencia: "propia", fechaCreacion: "2024-07-01", estadoPropiedad: "activa" },
  { id: 9, clienteId: 6, rol: "7890-12", comuna: "Santiago", tipoTenencia: "propia", fechaCreacion: "2024-08-10", estadoPropiedad: "activa" },
];

// ============================================
// CONTACTOS
// ============================================
export const contactos: Contacto[] = [
  { id: 1, clienteId: 1, nombre: "Roberto Fuentes", email: "rfuentes@elroble.cl", telefono: "+56 9 8765 4321", rol: "representante_legal", principal: true },
  { id: 2, clienteId: 1, nombre: "Carolina Mendez", email: "cmendez@elroble.cl", telefono: "+56 9 7654 3210", rol: "contador", principal: false },
  { id: 3, clienteId: 2, nombre: "Pedro Sanchez", email: "psanchez@pacifico.cl", telefono: "+56 9 6543 2109", rol: "representante_legal", principal: true },
  { id: 4, clienteId: 3, nombre: "Ana Maria Torres", email: "atorres@mineralosandes.cl", telefono: "+56 9 5432 1098", rol: "contacto_principal", principal: true },
  { id: 5, clienteId: 3, nombre: "Miguel Fernandez", email: "mfernandez@mineralosandes.cl", rol: "administrador", principal: false },
  { id: 6, clienteId: 6, nombre: "Sofia Martinez", email: "sofia.martinez@gmail.com", telefono: "+56 9 4321 0987", rol: "contacto_principal", principal: true },
];

// ============================================
// ANALISIS ESTUDIOS
// ============================================
export const analisisEstudios: AnalisisEstudio[] = [
  {
    id: 1,
    holdingId: 3,
    titulo: "Estudio Sobretasa Terreno Industrial Antofagasta",
    descripcion: "Evaluacion de sobretasa en terrenos industriales de Minera Los Andes",
    estado: "completado",
    arquitectoId: 3,
    abogadoId: 4,
    fechaCreacion: "2024-06-15",
    fechaActualizacion: "2024-07-20",
  },
  {
    id: 2,
    holdingId: 2,
    titulo: "Estudio Avaluo Providencia Norte",
    descripcion: "Revision de avaluo fiscal en propiedades de Providencia",
    estado: "en_estudio",
    arquitectoId: 3,
    fechaCreacion: "2024-10-01",
    fechaActualizacion: "2024-10-25",
  },
  {
    id: 3,
    holdingId: 1,
    titulo: "Estudio AUP Las Condes - El Roble",
    descripcion: "Evaluacion de oportunidad de actualizacion de avaluo en Las Condes",
    estado: "completado",
    arquitectoId: 3,
    abogadoId: 4,
    fechaCreacion: "2024-08-01",
    fechaActualizacion: "2024-09-10",
  },
];

export const analisisEstudioPropiedades: AnalisisEstudioPropiedad[] = [
  {
    id: 1,
    analisisEstudioId: 1,
    propiedadId: 5,
    resultado: "aprobado_para_solicitud",
    observaciones: "Sobrevaloracion detectada en terreno industrial. Oportunidad de rebaja de sobretasa.",
    hipotesisSeleccionadas: ["avaluo_terreno.superficie_terreno", "avaluo_terreno.destino_terreno"],
    fechaResultado: "2024-07-15",
  },
  {
    id: 2,
    analisisEstudioId: 1,
    propiedadId: 6,
    resultado: "aprobado_para_solicitud",
    observaciones: "Terreno contiguo con misma problematica de sobretasa.",
    hipotesisSeleccionadas: ["avaluo_terreno.destino_terreno"],
    fechaResultado: "2024-07-18",
  },
  {
    id: 3,
    analisisEstudioId: 2,
    propiedadId: 4,
    resultado: "pendiente",
    observaciones: "En proceso de evaluacion. Pendiente visita a terreno.",
  },
  {
    id: 4,
    analisisEstudioId: 3,
    propiedadId: 1,
    resultado: "aprobado_para_solicitud",
    observaciones: "Sobrevaloracion del terreno en un 30%. Oportunidad clara de rebaja.",
    hipotesisSeleccionadas: ["avaluo_terreno.superficie_terreno", "avaluo_construccion.calidad_construccion"],
    fechaResultado: "2024-09-05",
  },
  {
    id: 5,
    analisisEstudioId: 3,
    propiedadId: 2,
    resultado: "aprobado_para_solicitud",
    observaciones: "Avaluo fiscal no refleja estado real de la propiedad.",
    hipotesisSeleccionadas: ["avaluo_construccion.calidad_construccion"],
    fechaResultado: "2024-09-08",
  },
];

export const bitacoraAnalisis: EntradaBitacoraAnalisis[] = [
  { id: 1, analisisEstudioId: 1, usuarioId: 3, contenido: "Inicio de estudio. Se solicitan antecedentes de ambos terrenos industriales.", fechaCreacion: "2024-06-15T10:00:00" },
  { id: 2, analisisEstudioId: 1, propiedadId: 5, usuarioId: 3, contenido: "Visita a terreno ROL 4567-89. Se confirma sobrevaloracion.", fechaCreacion: "2024-07-01T14:00:00" },
  { id: 3, analisisEstudioId: 1, usuarioId: 4, contenido: "Estudio completado. Ambos ROLes aprobados para solicitud.", fechaCreacion: "2024-07-20T11:00:00" },
  { id: 4, analisisEstudioId: 2, usuarioId: 3, contenido: "Inicio revision de avaluo en Providencia Norte. Pendiente visita.", fechaCreacion: "2024-10-01T09:00:00" },
  { id: 5, analisisEstudioId: 3, usuarioId: 3, contenido: "Estudio iniciado para propiedades El Roble en Las Condes.", fechaCreacion: "2024-08-01T10:00:00" },
  { id: 6, analisisEstudioId: 3, propiedadId: 1, usuarioId: 3, contenido: "ROL 1234-56: terreno sobrevaluado en 30%. Recomendacion de AUP.", fechaCreacion: "2024-09-05T14:30:00" },
  { id: 7, analisisEstudioId: 3, usuarioId: 4, contenido: "Ambos ROLes aprobados. Se procedera a crear solicitud.", fechaCreacion: "2024-09-10T11:00:00" },
];

// ============================================
// SOLICITUDES (Casos) — Flujo nuevo
// ============================================
//
// Caso 1: AUP Las Condes → GANADO → Cobro 1 (facturado) + Tesoreria 1 (esperando_pago)
// Caso 2: Sobretasa Antofagasta → PARCIALMENTE_GANADO → Cobro 2 (pendiente) + Tesoreria 2 (esperando) + Reclamo 1 (en_tramite)
// Caso 3: RAV Providencia → EN_PREPARACION
// Caso 4: Vitacura → COBRO_FACTURACION → Cobro 3 (cobrado) + Tesoreria 3 (pago_recibido)
// Caso 5: DFL2 Nunoa → RESOLUCION
// Caso 6: Santiago Centro → DESISTIDO
// Caso 7: Antofagasta Norte → CONFIRMACION_PRESENTACION (poder pendiente)

export const casos: Caso[] = [
  {
    id: 1,
    holdingId: 1,
    titulo: "AUP Propiedad Las Condes",
    lugarPresentacion: "SII",
    usuario: "Oficina",
    categoriaPresentacion: "actualizacion_modificacion",
    tipoPresentacion: "Modificacion y/o revision de Avaluo de Terreno",
    estado: "ganado",
    ejecutivoId: 2,
    abogadoId: 4,
    arquitectoId: 3,
    rebajaEsperada: 45000000,
    honorario: 11250000,
    resultado: "ganado",
    analisisEstudioId: 3,
    fechaCreacion: "2024-09-15",
    fechaActualizacion: "2024-11-20",
    fechaPresentacion: "2024-09-25",
    fechaResolucion: "2024-11-20",
  },
  {
    id: 2,
    holdingId: 3,
    titulo: "Sobretasa Terreno Industrial Antofagasta",
    lugarPresentacion: "SII",
    usuario: "Oficina",
    categoriaPresentacion: "actualizacion_modificacion",
    tipoPresentacion: "Revision sobretasa Sitios No Edificados",
    estado: "parcialmente_ganado",
    ejecutivoId: 2,
    abogadoId: 4,
    arquitectoId: 3,
    rebajaEsperada: 80000000,
    honorario: 20000000,
    resultado: "parcialmente_ganado",
    analisisEstudioId: 1,
    fechaCreacion: "2024-07-25",
    fechaActualizacion: "2024-11-10",
    fechaPresentacion: "2024-08-15",
    fechaResolucion: "2024-11-10",
  },
  {
    id: 3,
    holdingId: 2,
    titulo: "RAV Terreno Providencia",
    lugarPresentacion: "SII",
    usuario: "Cliente",
    categoriaPresentacion: "rebajas_beneficios",
    tipoPresentacion: "Revision y/o Solicitud de Exencion de Impuesto Territorial",
    estado: "en_preparacion",
    ejecutivoId: 5,
    abogadoId: 4,
    rebajaEsperada: 15000000,
    honorario: 3750000,
    fechaCreacion: "2024-10-18",
    fechaActualizacion: "2024-11-05",
  },
  {
    id: 4,
    holdingId: 1,
    titulo: "Revision Avaluo Vitacura",
    lugarPresentacion: "SII",
    usuario: "Oficina",
    categoriaPresentacion: "actualizacion_modificacion",
    tipoPresentacion: "Modificacion y/o revision de Avaluo de Construccion",
    estado: "cobro_facturacion",
    ejecutivoId: 2,
    abogadoId: 4,
    arquitectoId: 3,
    rebajaEsperada: 18000000,
    honorario: 4500000,
    resultado: "ganado",
    fechaCreacion: "2024-06-01",
    fechaActualizacion: "2024-10-15",
    fechaPresentacion: "2024-06-20",
    fechaResolucion: "2024-09-30",
  },
  {
    id: 5,
    holdingId: 1,
    titulo: "Exencion DFL2 Nunoa",
    lugarPresentacion: "Municipalidad",
    usuario: "Oficina",
    categoriaPresentacion: "rebajas_beneficios",
    tipoPresentacion: "Solicitud de Exencion DFL2",
    estado: "resolucion",
    ejecutivoId: 5,
    abogadoId: 4,
    rebajaEsperada: 8000000,
    honorario: 2000000,
    fechaCreacion: "2024-09-01",
    fechaActualizacion: "2024-11-01",
    fechaPresentacion: "2024-10-10",
  },
  {
    id: 6,
    holdingId: 1,
    titulo: "AUP Santiago Centro",
    lugarPresentacion: "SII",
    usuario: "Cristobal",
    categoriaPresentacion: "actualizacion_modificacion",
    tipoPresentacion: "Modificacion y/o revision de Avaluo de Terreno",
    estado: "desistido",
    ejecutivoId: 5,
    motivoDesistimiento: "Cliente decidio no continuar tras evaluacion de costos vs beneficio esperado.",
    fechaCreacion: "2024-08-15",
    fechaActualizacion: "2024-09-20",
  },
  {
    id: 7,
    holdingId: 3,
    titulo: "Modificacion Avaluo Terreno Antofagasta Norte",
    lugarPresentacion: "SII",
    usuario: "Oficina",
    categoriaPresentacion: "actualizacion_modificacion",
    tipoPresentacion: "Modificacion y/o revision de Avaluo de Terreno",
    estado: "confirmacion_presentacion",
    ejecutivoId: 2,
    abogadoId: 4,
    arquitectoId: 3,
    rebajaEsperada: 35000000,
    honorario: 8750000,
    poderPendiente: true,
    fechaCreacion: "2024-10-01",
    fechaActualizacion: "2024-11-15",
  },
];

// ============================================
// CASO-PROPIEDADES
// ============================================
export const casoPropiedades: CasoPropiedad[] = [
  { id: 1, casoId: 1, propiedadId: 1 },
  { id: 2, casoId: 1, propiedadId: 2 },
  { id: 3, casoId: 2, propiedadId: 5 },
  { id: 4, casoId: 2, propiedadId: 6 },
  { id: 5, casoId: 3, propiedadId: 3 },
  { id: 6, casoId: 4, propiedadId: 8 },
  { id: 7, casoId: 5, propiedadId: 7 },
  { id: 8, casoId: 6, propiedadId: 9 },
  { id: 9, casoId: 7, propiedadId: 6 },
];

// ============================================
// PODERES
// ============================================
export const poderes: Poder[] = [
  {
    id: 1,
    clienteId: 1,
    tipoDocumento: "Poder Notarial",
    fechaOtorgamiento: "2024-01-20",
    fechaVencimiento: "2025-01-20",
    estado: "vigente",
    observaciones: "Poder general para representacion ante SII",
  },
  {
    id: 2,
    clienteId: 2,
    tipoDocumento: "Poder Simple",
    fechaOtorgamiento: "2024-04-01",
    estado: "vigente",
    observaciones: "Poder para tramites municipales",
  },
  {
    id: 3,
    clienteId: 3,
    tipoDocumento: "Poder Notarial",
    fechaOtorgamiento: "2024-05-15",
    fechaVencimiento: "2025-05-15",
    estado: "vigente",
    observaciones: "Poder amplio para representacion ante SII y TTA",
  },
];

// ============================================
// ESTUDIOS (legacy)
// ============================================
export const estudios: Estudio[] = [
  { id: 1, casoId: 1, propiedadId: 1, arquitectoId: 3, hayOportunidad: true, observaciones: "Sobrevaloracion del terreno detectada en estudio previo", estado: "completado", fechaInicio: "2024-09-16", fechaFin: "2024-09-20" },
  { id: 2, casoId: 1, propiedadId: 2, arquitectoId: 3, hayOportunidad: true, observaciones: "Avaluo fiscal no refleja estado real", estado: "completado", fechaInicio: "2024-09-16", fechaFin: "2024-09-20" },
  { id: 3, casoId: 3, propiedadId: 3, arquitectoId: 3, estado: "en_progreso", fechaInicio: "2024-10-20" },
];

// ============================================
// SOLICITUDES (presentaciones formales por ROL)
// ============================================
export const solicitudes: Solicitud[] = [
  { id: 1, casoId: 1, propiedadId: 1, poderId: 1, estado: "resuelta", numeroSolicitud: "SII-4422921", fechaEnvio: "2024-09-25", fechaRespuesta: "2024-11-20", observaciones: "Resolucion favorable. Rebaja aprobada." },
  { id: 2, casoId: 1, propiedadId: 2, poderId: 1, estado: "resuelta", numeroSolicitud: "SII-4422922", fechaEnvio: "2024-09-25", fechaRespuesta: "2024-11-20", observaciones: "Resolucion favorable." },
  { id: 3, casoId: 2, propiedadId: 5, poderId: 3, estado: "resuelta", numeroSolicitud: "SII-4511033", fechaEnvio: "2024-08-15", fechaRespuesta: "2024-11-10", observaciones: "Parcialmente favorable: rebaja concedida solo para ROL 4567-89." },
  { id: 4, casoId: 2, propiedadId: 6, poderId: 3, estado: "rechazada", numeroSolicitud: "SII-4511034", fechaEnvio: "2024-08-15", fechaRespuesta: "2024-11-10", observaciones: "Rechazada. SII no acepto argumento para ROL 4567-90." },
  { id: 5, casoId: 4, propiedadId: 8, poderId: 1, estado: "resuelta", numeroSolicitud: "SII-4399887", fechaEnvio: "2024-06-20", fechaRespuesta: "2024-09-30", observaciones: "Resolucion favorable." },
  { id: 6, casoId: 5, propiedadId: 7, estado: "enviada", numeroSolicitud: "MUN-2024-1155", fechaEnvio: "2024-10-10", observaciones: "Presentacion ante Municipalidad de Nunoa." },
];

// ============================================
// GASTOS
// ============================================
export const gastos: Gasto[] = [
  { id: 1, casoId: 1, tipo: "tramite", descripcion: "Certificado de dominio vigente ROL 1234-56", monto: 15000, fecha: "2024-09-16", responsableId: 2 },
  { id: 2, casoId: 1, tipo: "tramite", descripcion: "Certificado de dominio vigente ROL 1234-57", monto: 15000, fecha: "2024-09-16", responsableId: 2 },
  { id: 3, casoId: 1, tipo: "traslado", descripcion: "Visita a propiedades Las Condes", monto: 25000, fecha: "2024-09-17", responsableId: 3 },
  { id: 4, casoId: 2, tipo: "viaje", descripcion: "Viaje a Antofagasta - inspeccion terrenos", monto: 280000, fecha: "2024-07-28", responsableId: 3 },
  { id: 5, casoId: 2, tipo: "tramite", descripcion: "Certificados SII ROLes Antofagasta", monto: 30000, fecha: "2024-08-01", responsableId: 2 },
  { id: 6, casoId: 3, tipo: "tramite", descripcion: "Certificado avaluo fiscal Providencia", monto: 12000, fecha: "2024-10-22", responsableId: 5 },
  { id: 7, casoId: 4, tipo: "traslado", descripcion: "Visita propiedad Vitacura", monto: 18000, fecha: "2024-06-05", responsableId: 3 },
  { id: 8, casoId: 5, tipo: "tramite", descripcion: "Certificado DFL2 Municipalidad Nunoa", monto: 8500, fecha: "2024-10-08", responsableId: 5 },
];

// ============================================
// BITACORA
// ============================================
export const bitacora: EntradaBitacora[] = [
  // Caso 1
  { id: 1, casoId: 1, usuarioId: 2, contenido: "Solicitud creada desde estudio de Las Condes. 2 ROLes aprobados.", fechaCreacion: "2024-09-15T10:00:00" },
  { id: 2, casoId: 1, propiedadId: 1, usuarioId: 3, contenido: "Estudio completado para ROL 1234-56. Sobrevaloracion confirmada en 30%.", fechaCreacion: "2024-09-20T14:00:00" },
  { id: 3, casoId: 1, usuarioId: 4, contenido: "Presentacion ingresada al SII. Numeros SII-4422921 y SII-4422922.", fechaCreacion: "2024-09-25T11:30:00" },
  { id: 4, casoId: 1, usuarioId: 2, contenido: "SII emitio resolucion favorable para ambos ROLes. Caso ganado.", fechaCreacion: "2024-11-20T15:00:00" },
  // Caso 2
  { id: 5, casoId: 2, usuarioId: 2, contenido: "Solicitud creada desde estudio Antofagasta. Sobretasa en 2 terrenos industriales.", fechaCreacion: "2024-07-25T09:00:00" },
  { id: 6, casoId: 2, usuarioId: 3, contenido: "Viaje a Antofagasta completado. Ambos terrenos inspeccionados.", fechaCreacion: "2024-07-30T18:00:00" },
  { id: 7, casoId: 2, usuarioId: 4, contenido: "Presentaciones ingresadas. Numeros SII-4511033 y SII-4511034.", fechaCreacion: "2024-08-15T10:00:00" },
  { id: 8, casoId: 2, usuarioId: 2, contenido: "Resolucion parcial: ROL 4567-89 aprobado, ROL 4567-90 rechazado. Se evaluara reclamo.", fechaCreacion: "2024-11-10T16:00:00" },
  // Caso 3
  { id: 9, casoId: 3, usuarioId: 5, contenido: "Caso iniciado. Cliente entregara documentos la proxima semana.", fechaCreacion: "2024-10-18T09:00:00" },
  { id: 10, casoId: 3, usuarioId: 5, contenido: "Documentos recibidos. Se inicia preparacion de solicitud.", fechaCreacion: "2024-10-28T11:00:00" },
  // Caso 4
  { id: 11, casoId: 4, usuarioId: 2, contenido: "Caso ganado. Resolucion SII favorable. Se procede a cobro.", fechaCreacion: "2024-09-30T15:00:00" },
  { id: 12, casoId: 4, usuarioId: 2, contenido: "Certificado de avaluo provisional obtenido. Factura emitida al cliente.", fechaCreacion: "2024-10-15T10:00:00" },
  // Caso 5
  { id: 13, casoId: 5, usuarioId: 5, contenido: "Solicitud DFL2 presentada ante Municipalidad de Nunoa.", fechaCreacion: "2024-10-10T14:00:00" },
  { id: 14, casoId: 5, usuarioId: 5, contenido: "Municipalidad acusa recibo. Plazo estimado de respuesta: 30 dias habiles.", fechaCreacion: "2024-10-15T09:30:00" },
  // Caso 6
  { id: 15, casoId: 6, usuarioId: 5, contenido: "Caso creado para revision de avaluo en Santiago Centro.", fechaCreacion: "2024-08-15T10:00:00" },
  { id: 16, casoId: 6, usuarioId: 1, contenido: "Desistido: costo-beneficio no justifica la presentacion.", fechaCreacion: "2024-09-20T11:00:00" },
  // Caso 7
  { id: 17, casoId: 7, usuarioId: 2, contenido: "Solicitud en preparacion para segundo terreno Antofagasta.", fechaCreacion: "2024-10-01T10:00:00" },
  { id: 18, casoId: 7, usuarioId: 4, contenido: "Documentacion lista. Pendiente confirmacion de poder para presentar.", fechaCreacion: "2024-11-15T14:00:00" },
];

// ============================================
// DOCUMENTOS
// ============================================
export const documentos: Documento[] = [
  // Caso 1 - AUP Las Condes (ganado)
  { id: 1, casoId: 1, nombre: "Poder_Inversiones_El_Roble.pdf", tipo: "pdf", tamano: "890 KB", clasificacion: "Poder", subidoPor: 2, fechaSubida: "2024-09-16T10:30:00" },
  { id: 2, casoId: 1, propiedadId: 1, nombre: "Plano_Oficina_1234-56.pdf", tipo: "pdf", tamano: "2.3 MB", clasificacion: "Plano", subidoPor: 3, fechaSubida: "2024-09-18T14:00:00" },
  { id: 3, casoId: 1, propiedadId: 1, nombre: "Escritura_Propiedad_1234-56.pdf", tipo: "pdf", tamano: "1.5 MB", clasificacion: "Escritura", subidoPor: 2, fechaSubida: "2024-09-17T09:00:00" },
  { id: 4, casoId: 1, propiedadId: 2, nombre: "Plano_Oficina_1234-57.pdf", tipo: "pdf", tamano: "1.8 MB", clasificacion: "Plano", subidoPor: 3, fechaSubida: "2024-09-18T15:00:00" },
  { id: 5, casoId: 1, nombre: "Resolucion_SII_LasCondes.pdf", tipo: "pdf", tamano: "420 KB", clasificacion: "Respuesta SII", subidoPor: 4, fechaSubida: "2024-11-20T16:00:00" },
  // Caso 2 - Sobretasa Antofagasta (parcialmente ganado)
  { id: 6, casoId: 2, nombre: "Poder_Minera_Los_Andes.pdf", tipo: "pdf", tamano: "920 KB", clasificacion: "Poder", subidoPor: 2, fechaSubida: "2024-08-01T10:00:00" },
  { id: 7, casoId: 2, propiedadId: 5, nombre: "Informe_Terreno_4567-89.pdf", tipo: "pdf", tamano: "3.1 MB", clasificacion: "Informe Tecnico", subidoPor: 3, fechaSubida: "2024-07-30T18:30:00" },
  { id: 8, casoId: 2, propiedadId: 6, nombre: "Informe_Terreno_4567-90.pdf", tipo: "pdf", tamano: "2.8 MB", clasificacion: "Informe Tecnico", subidoPor: 3, fechaSubida: "2024-07-30T19:00:00" },
  { id: 9, casoId: 2, nombre: "Resolucion_Parcial_SII.pdf", tipo: "pdf", tamano: "550 KB", clasificacion: "Respuesta SII", subidoPor: 4, fechaSubida: "2024-11-10T17:00:00" },
  // Caso 3 - RAV Providencia (en preparacion)
  { id: 10, casoId: 3, propiedadId: 3, nombre: "Certificado_Avaluo_Providencia.pdf", tipo: "pdf", tamano: "320 KB", clasificacion: "Certificado", subidoPor: 5, fechaSubida: "2024-10-22T11:00:00" },
  // Caso 4 - Vitacura (cobro_facturacion)
  { id: 11, casoId: 4, propiedadId: 8, nombre: "Plano_Vitacura_2345-67.pdf", tipo: "pdf", tamano: "1.9 MB", clasificacion: "Plano", subidoPor: 3, fechaSubida: "2024-06-08T14:00:00" },
  { id: 12, casoId: 4, nombre: "Resolucion_SII_Vitacura.pdf", tipo: "pdf", tamano: "380 KB", clasificacion: "Respuesta SII", subidoPor: 4, fechaSubida: "2024-09-30T16:00:00" },
  { id: 13, casoId: 4, nombre: "Certificado_Avaluo_Provisional.pdf", tipo: "pdf", tamano: "290 KB", clasificacion: "Certificado Avaluo", subidoPor: 2, fechaSubida: "2024-10-10T10:00:00" },
  { id: 14, casoId: 4, nombre: "Factura_Cobro_Vitacura.pdf", tipo: "pdf", tamano: "150 KB", clasificacion: "Factura", subidoPor: 1, fechaSubida: "2024-10-15T11:00:00" },
  // Caso 5 - DFL2 Nunoa (resolucion)
  { id: 15, casoId: 5, propiedadId: 7, nombre: "Certificado_DFL2_Nunoa.pdf", tipo: "pdf", tamano: "280 KB", clasificacion: "Certificado", subidoPor: 5, fechaSubida: "2024-10-08T15:00:00" },
  { id: 16, casoId: 5, nombre: "Solicitud_Municipalidad_Nunoa.pdf", tipo: "pdf", tamano: "450 KB", clasificacion: "Solicitud", subidoPor: 5, fechaSubida: "2024-10-10T14:30:00" },
  // Analisis - Estudio 1 (Antofagasta)
  { id: 17, analisisEstudioId: 1, propiedadId: 5, nombre: "Fotos_Terreno_Antofagasta_1.jpg", tipo: "imagen", tamano: "4.2 MB", clasificacion: "Fotografias", subidoPor: 3, fechaSubida: "2024-07-01T15:00:00" },
  { id: 18, analisisEstudioId: 1, propiedadId: 6, nombre: "Fotos_Terreno_Antofagasta_2.jpg", tipo: "imagen", tamano: "3.8 MB", clasificacion: "Fotografias", subidoPor: 3, fechaSubida: "2024-07-01T15:30:00" },
  // Analisis - Estudio 3 (Las Condes)
  { id: 19, analisisEstudioId: 3, propiedadId: 1, nombre: "Avaluo_Fiscal_LasCondes_1234-56.pdf", tipo: "pdf", tamano: "520 KB", clasificacion: "Avaluo Fiscal", subidoPor: 3, fechaSubida: "2024-08-05T10:00:00" },
  { id: 20, analisisEstudioId: 3, propiedadId: 2, nombre: "Avaluo_Fiscal_LasCondes_1234-57.pdf", tipo: "pdf", tamano: "480 KB", clasificacion: "Avaluo Fiscal", subidoPor: 3, fechaSubida: "2024-08-05T10:30:00" },
  // Caso 7 - Antofagasta Norte (confirmacion_presentacion)
  { id: 21, casoId: 7, propiedadId: 6, nombre: "Informe_Complementario_4567-90.pdf", tipo: "pdf", tamano: "1.2 MB", clasificacion: "Informe Tecnico", subidoPor: 3, fechaSubida: "2024-11-10T14:00:00" },
];

// ============================================
// RECLAMOS
// ============================================
export const reclamos: Reclamo[] = [
  {
    id: 1,
    solicitudId: 2,
    analisisEstudioId: 1,
    holdingId: 3,
    titulo: "Reclamo Reposicion: Sobretasa ROL 4567-90",
    estado: "en_tramite",
    tipoReclamo: "reposicion_sii",
    motivoReclamo: "SII rechazo rebaja de sobretasa para ROL 4567-90 sin considerar informe tecnico que demuestra uso efectivo del terreno industrial.",
    ejecutivoId: 2,
    abogadoId: 4,
    fechaCreacion: "2024-11-12",
    fechaActualizacion: "2024-11-25",
  },
];

// ============================================
// COBROS
// ============================================
export const cobros: Cobro[] = [
  {
    id: 1,
    solicitudId: 1,
    holdingId: 1,
    estado: "facturado",
    montoCobro: 11250000,
    observaciones: "Factura emitida por honorarios caso AUP Las Condes. Pendiente pago del cliente.",
    fechaCreacion: "2024-11-21",
    fechaActualizacion: "2024-12-01",
  },
  {
    id: 2,
    solicitudId: 2,
    holdingId: 3,
    estado: "pendiente_certificado",
    montoCobro: 10000000,
    observaciones: "Cobro parcial por ROL 4567-89 aprobado. Pendiente certificado de avaluo provisional.",
    fechaCreacion: "2024-11-12",
    fechaActualizacion: "2024-11-12",
  },
  {
    id: 3,
    solicitudId: 4,
    holdingId: 1,
    estado: "cobrado",
    montoCobro: 4500000,
    certificadoAvaluoId: 13,
    observaciones: "Cobro completado. Pago recibido del cliente.",
    fechaCreacion: "2024-10-01",
    fechaActualizacion: "2024-11-05",
    fechaCobro: "2024-11-05",
  },
];

// ============================================
// TESORERIA
// ============================================
export const tesoreriaItems: Tesoreria[] = [
  {
    id: 1,
    solicitudId: 1,
    holdingId: 1,
    estado: "esperando_pago",
    montoPago: 45000000,
    observaciones: "Rebaja aprobada por SII. Plazo estimado de devolucion: 6-12 meses.",
    fechaCreacion: "2024-11-21",
    fechaActualizacion: "2024-11-21",
  },
  {
    id: 2,
    solicitudId: 2,
    holdingId: 3,
    estado: "esperando_pago",
    montoPago: 40000000,
    observaciones: "Devolucion parcial por ROL 4567-89. Monto estimado.",
    fechaCreacion: "2024-11-12",
    fechaActualizacion: "2024-11-12",
  },
  {
    id: 3,
    solicitudId: 4,
    holdingId: 1,
    estado: "pago_recibido",
    montoPago: 18000000,
    observaciones: "Devolucion recibida del SII.",
    fechaCreacion: "2024-10-01",
    fechaActualizacion: "2024-12-20",
    fechaPago: "2024-12-20",
  },
];

// ============================================
// EVENTOS DE ESTADO (historial de transiciones)
// ============================================
export const eventosEstado: EventoEstado[] = [
  // --- Caso 1: AUP Las Condes → ganado ---
  { id: 1, entidadTipo: "solicitud", entidadId: 1, estadoAnterior: "rol_listo", estadoNuevo: "en_preparacion", comentario: "Inicio preparacion de documentacion para presentacion ante SII.", usuarioId: 2, fecha: "2024-09-16" },
  { id: 2, entidadTipo: "solicitud", entidadId: 1, estadoAnterior: "en_preparacion", estadoNuevo: "confirmacion_presentacion", comentario: "Documentacion completa. Pendiente confirmacion final.", usuarioId: 4, fecha: "2024-09-22" },
  { id: 3, entidadTipo: "solicitud", entidadId: 1, estadoAnterior: "confirmacion_presentacion", estadoNuevo: "solicitud_administrativa", comentario: "Presentacion confirmada e ingresada al SII.", usuarioId: 4, fecha: "2024-09-25" },
  { id: 4, entidadTipo: "solicitud", entidadId: 1, estadoAnterior: "solicitud_administrativa", estadoNuevo: "resolucion", comentario: "SII acusa recibo. En espera de resolucion.", usuarioId: 2, fecha: "2024-10-15" },
  { id: 5, entidadTipo: "solicitud", entidadId: 1, estadoAnterior: "resolucion", estadoNuevo: "ganado", comentario: "Resolucion favorable para ambos ROLes. Rebaja de $45M aprobada.", usuarioId: 2, fecha: "2024-11-20" },

  // --- Caso 2: Sobretasa Antofagasta → parcialmente_ganado ---
  { id: 6, entidadTipo: "solicitud", entidadId: 2, estadoAnterior: "rol_listo", estadoNuevo: "en_preparacion", comentario: "Inicio preparacion post-viaje a Antofagasta.", usuarioId: 2, fecha: "2024-07-30" },
  { id: 7, entidadTipo: "solicitud", entidadId: 2, estadoAnterior: "en_preparacion", estadoNuevo: "confirmacion_presentacion", comentario: "Informes tecnicos listos. Pendiente revision legal.", usuarioId: 3, fecha: "2024-08-08" },
  { id: 8, entidadTipo: "solicitud", entidadId: 2, estadoAnterior: "confirmacion_presentacion", estadoNuevo: "solicitud_administrativa", comentario: "Presentacion ingresada para ambos ROLes.", usuarioId: 4, fecha: "2024-08-15" },
  { id: 9, entidadTipo: "solicitud", entidadId: 2, estadoAnterior: "solicitud_administrativa", estadoNuevo: "resolucion", comentario: "En tramite ante SII.", usuarioId: 2, fecha: "2024-09-20" },
  { id: 10, entidadTipo: "solicitud", entidadId: 2, estadoAnterior: "resolucion", estadoNuevo: "parcialmente_ganado", comentario: "ROL 4567-89 aprobado. ROL 4567-90 rechazado. Se evaluara recurso de reposicion.", usuarioId: 2, fecha: "2024-11-10" },

  // --- Caso 4: Vitacura → ganado → cobro_facturacion ---
  { id: 11, entidadTipo: "solicitud", entidadId: 4, estadoAnterior: "resolucion", estadoNuevo: "ganado", comentario: "Resolucion favorable. Rebaja de avaluo de construccion aprobada.", usuarioId: 2, fecha: "2024-09-30" },
  { id: 12, entidadTipo: "solicitud", entidadId: 4, estadoAnterior: "ganado", estadoNuevo: "cobro_facturacion", comentario: "Certificado obtenido y factura emitida. En proceso de cobro al cliente.", usuarioId: 2, fecha: "2024-10-15" },

  // --- Caso 5: DFL2 Nunoa → resolucion ---
  { id: 13, entidadTipo: "solicitud", entidadId: 5, estadoAnterior: "rol_listo", estadoNuevo: "en_preparacion", comentario: "Inicio preparacion solicitud DFL2.", usuarioId: 5, fecha: "2024-09-05" },
  { id: 14, entidadTipo: "solicitud", entidadId: 5, estadoAnterior: "en_preparacion", estadoNuevo: "confirmacion_presentacion", comentario: "Documentos listos para presentar.", usuarioId: 5, fecha: "2024-10-05" },
  { id: 15, entidadTipo: "solicitud", entidadId: 5, estadoAnterior: "confirmacion_presentacion", estadoNuevo: "solicitud_administrativa", comentario: "Presentado ante Municipalidad de Nunoa.", usuarioId: 5, fecha: "2024-10-10" },
  { id: 16, entidadTipo: "solicitud", entidadId: 5, estadoAnterior: "solicitud_administrativa", estadoNuevo: "resolucion", comentario: "Municipalidad acuso recibo. Plazo 30 dias habiles.", usuarioId: 5, fecha: "2024-11-01" },

  // --- Caso 6: Santiago Centro → desistido ---
  { id: 17, entidadTipo: "solicitud", entidadId: 6, estadoAnterior: "rol_listo", estadoNuevo: "en_preparacion", comentario: "Inicio evaluacion de oportunidad.", usuarioId: 5, fecha: "2024-08-20" },
  { id: 18, entidadTipo: "solicitud", entidadId: 6, estadoAnterior: "en_preparacion", estadoNuevo: "desistido", comentario: "Cliente decidio no continuar tras evaluacion de costos vs beneficio esperado.", usuarioId: 1, fecha: "2024-09-20" },

  // --- Caso 7: Antofagasta Norte → confirmacion_presentacion ---
  { id: 19, entidadTipo: "solicitud", entidadId: 7, estadoAnterior: "rol_listo", estadoNuevo: "en_preparacion", comentario: "Preparacion para segundo terreno Antofagasta.", usuarioId: 2, fecha: "2024-10-05" },
  { id: 20, entidadTipo: "solicitud", entidadId: 7, estadoAnterior: "en_preparacion", estadoNuevo: "confirmacion_presentacion", comentario: "Documentacion lista. Pendiente poder notarial.", usuarioId: 4, fecha: "2024-11-15" },

  // --- Reclamo 1: preparacion → presentado → en_tramite ---
  { id: 21, entidadTipo: "reclamo", entidadId: 1, estadoAnterior: "preparacion", estadoNuevo: "presentado", comentario: "Recurso de reposicion presentado ante SII por rechazo de ROL 4567-90.", usuarioId: 4, fecha: "2024-11-18" },
  { id: 22, entidadTipo: "reclamo", entidadId: 1, estadoAnterior: "presentado", estadoNuevo: "en_tramite", comentario: "SII acusa recibo del recurso. En tramite.", usuarioId: 2, fecha: "2024-11-25" },

  // --- Cobro 3 (Vitacura): pendiente → certificado → facturado → cobrado ---
  { id: 23, entidadTipo: "cobro", entidadId: 3, estadoAnterior: "pendiente_certificado", estadoNuevo: "certificado_obtenido", comentario: "Certificado de avaluo provisional obtenido.", usuarioId: 2, fecha: "2024-10-10" },
  { id: 24, entidadTipo: "cobro", entidadId: 3, estadoAnterior: "certificado_obtenido", estadoNuevo: "facturado", comentario: "Factura emitida al cliente por $4.500.000.", usuarioId: 1, fecha: "2024-10-15" },
  { id: 25, entidadTipo: "cobro", entidadId: 3, estadoAnterior: "facturado", estadoNuevo: "cobrado", comentario: "Pago recibido del cliente.", usuarioId: 1, fecha: "2024-11-05" },

  // --- Cobro 1 (Las Condes): pendiente → certificado → facturado ---
  { id: 26, entidadTipo: "cobro", entidadId: 1, estadoAnterior: "pendiente_certificado", estadoNuevo: "certificado_obtenido", comentario: "Certificado de avaluo provisional obtenido.", usuarioId: 2, fecha: "2024-11-25" },
  { id: 27, entidadTipo: "cobro", entidadId: 1, estadoAnterior: "certificado_obtenido", estadoNuevo: "facturado", comentario: "Factura emitida por $11.250.000.", usuarioId: 1, fecha: "2024-12-01" },

  // --- Tesoreria 3 (Vitacura): esperando → pago_recibido ---
  { id: 28, entidadTipo: "tesoreria", entidadId: 3, estadoAnterior: "esperando_pago", estadoNuevo: "pago_recibido", comentario: "Devolucion del SII recibida. Monto: $18.000.000.", usuarioId: 1, fecha: "2024-12-20" },
];
